// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2obJu","standardFormContainer":"styles_standardFormContainer__2Ngg5","title":"styles_title__1OsnZ"};